const DeliveryTableColumnDefinitions = [

    {
        displayOrder: 1,
        headerName: window.translate('Station'),
        field: 'stationName',
        type: 'text',
        width: 'auto',
        sortable: true,
        sortOrder: ''
    },
    {
        displayOrder: 2,
        headerName: window.translate('Airtime Cost'),
        field: 'valueSpot',
        type: 'currency',
        width: 'auto',
        sortable: true,
        sortOrder: '',
        totals: 'sum'
    },
    {
        displayOrder: 3,
        headerName: window.translate('Spots'),
        field: 'spotCount',
        type: 'text',
        width: 'auto',
        sortable: true,
        sortOrder: '',
        totals: 'sum'
    },
    {
        displayOrder: 4,
        headerName: window.translate('Impacts'),
        field: 'overallImpacts',
        type: 'number',
        width: 'auto',
        sortable: true,
        sortOrder: '',
        totals: 'sum'
    },
    {
        displayOrder: 5,
        headerName: window.translate('Reach'),
        field: 'overallReach',
        type: 'number',
        width: 'auto',
        sortable: true,
        sortOrder: '',
        totals: 'avg'
    },
    {
        displayOrder: 6,
        headerName: window.translate('Reach%'),
        field: 'reachPr',
        type: 'text',
        width: 'auto',
        sortable: true,
        sortOrder: '',
        totals: 'avg'
    },
    {
        displayOrder: 7,
        headerName: window.translate('Population'),
        field: 'overallPopulation',
        type: 'number',
        width: 'auto',
        sortable: true,
        sortOrder: '',
        totals: 'sum'
    },
    {
        displayOrder: 8,
        headerName: window.translate('Ratings'),
        field: 'ratings',
        type: 'text',
        width: 'auto',
        sortable: true,
        sortOrder: '',
        totals: 'avg'
    },
    {
        displayOrder: 9,
        headerName: window.translate('OTH'),
        field: 'overallOTH',
        type: 'number',
        width: 'auto',
        sortable: true,
        sortOrder: '',
        totals: 'avg'
    }
];


export default DeliveryTableColumnDefinitions;
